// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1DC8J","title":"Header_title__35YUI","side":"Header_side__2PQ1X"};